import { SerializedConstructor } from '@langchain/core/load/serializable';
import { FormLabel } from '@mui/joy';

import { useState } from 'react';

import { normalizeKwargsName } from '@/Pages/Playground/utils/Playground.utils';
import { CodeCard } from '@/components/Code/Code';

import { Manifest, ManifestPreview } from '../../Manifest';
import { ManifestEditorProps } from '../../Manifest.utils';
import { ManifestNavigation } from '../../ManifestNavigation';

export function ManifestLLMChain(
  props: ManifestEditorProps<SerializedConstructor>
) {
  const kwargs = props.value.kwargs;
  const [activeKey, setActiveKey] = useState<string | null>(null);

  if (activeKey != null) {
    let options = props.options;
    let onOptionsChange = props.onOptionsChange;

    // treat options as llm_kwargs, similarly to how
    // LLMChain works internally
    if (activeKey === 'llm') {
      options = kwargs.llm_kwargs ?? {};
      onOptionsChange = (llm_kwargs) => {
        props.onChange({
          ...props.value,
          kwargs: { ...(kwargs ?? {}), llm_kwargs },
        });
      };
    }

    return (
      <Manifest
        {...props}
        navigation={{
          onBack: () => setActiveKey(null),
          parent: 'LLMChain',
          name: normalizeKwargsName(activeKey),
        }}
        value={kwargs[activeKey]}
        onChange={(value) => {
          const kwargs = (props.value as SerializedConstructor)?.kwargs;
          props.onChange({
            ...props.value,
            kwargs: { ...(kwargs ?? {}), [activeKey]: value },
          });
        }}
        options={options}
        onOptionsChange={onOptionsChange}
      />
    );
  }

  return (
    <CodeCard sx={{ p: 2, flexDirection: 'column', display: 'flex', gap: 2 }}>
      <ManifestNavigation navigation={props.navigation} />

      <span className="font-semibold">LLMChain</span>

      <div className="flex flex-col gap-3">
        {Object.keys(kwargs)
          .filter((i) => i !== 'llm_kwargs')
          .map((key) => {
            return (
              <div key={key} className="flex flex-col gap-2">
                <FormLabel>{normalizeKwargsName(key)}</FormLabel>
                <ManifestPreview
                  value={kwargs[key]}
                  onClick={() => setActiveKey(key)}
                  options={props.options}
                />
              </div>
            );
          })}
      </div>
    </CodeCard>
  );
}
